import LoadableImage from "components/LoadableImage"
import { MediaEpisode } from "data/media"
import { Link } from "react-router-dom"
import { getYoutubeThumbnailUrl } from "utils/socialPreview"

interface Props {
  episode: MediaEpisode
  compact?: boolean
}

const formatLabel = (format: MediaEpisode["format"]) =>
  format === "video" ? "Video" : "Audio"

const MediaCard = ({ episode, compact = false }: Props) => {
  const thumbnail = getYoutubeThumbnailUrl(episode.youtubeId)

  return (
    <Link to={`/media/${episode.slug}`} className="gallery-card block h-full group">
      <div className="gallery-card-art min-h-0 p-3">
        <div className="relative aspect-video w-full overflow-hidden bg-gallery-subtle">
          {thumbnail ? (
            <LoadableImage
              src={thumbnail}
              alt={episode.title}
              loading="lazy"
              decoding="async"
              wrapperClassName="h-full w-full transition-transform duration-500 group-hover:scale-[1.025]"
              className="h-full w-full object-cover"
              loaderLabel="Loading episode"
              hideLoaderLabel
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center">
              <span className="gallery-label">Audio</span>
            </div>
          )}
          <span className="absolute bottom-3 left-3 bg-gallery-bg px-2 py-1 gallery-label text-gallery-text">
            {formatLabel(episode.format)}
          </span>
        </div>
      </div>

      <div className={`gallery-card-body ${compact ? "gap-4" : ""}`}>
        <div>
          <p className="gallery-label text-gallery-muted">{episode.seriesTitle}</p>
          <h3 className="font-serif text-[1.45rem] leading-tight font-normal text-gallery-text group-hover:text-gallery-accent transition-colors duration-200">
            {episode.title}
          </h3>
        </div>

        {!compact && (
          <p className="gallery-card-description">{episode.description}</p>
        )}

        <div className="gallery-card-foot">
          <span>{episode.date}{episode.duration ? ` / ${episode.duration}` : ""}</span>
          <span>View episode</span>
        </div>
      </div>
    </Link>
  )
}

export default MediaCard
